import React, { createContext, useState, useContext } from "react";
import { navigatorLanguageMapping } from "./utils/languageMapping";

const LanguageContext = createContext();

const getInitialLanguage = () => {
  return (
    localStorage.getItem("buckish-language") ||
    (navigator.language && navigator.language ? navigatorLanguageMapping[navigator.language] : "english")
  );
};

export const LanguageProvider = ({ children }) => {
  // const [language, setLanguage] = useState(getInitialLanguage());

  //Temporarily set the language for the session to english
  const [language, setLanguage] = useState("english")

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("buckish-language", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);